import { render, staticRenderFns } from "./Page6.vue?vue&type=template&id=df07c724&scoped=true&"
import script from "./Page6.vue?vue&type=script&lang=js&"
export * from "./Page6.vue?vue&type=script&lang=js&"
import style0 from "./Page6.vue?vue&type=style&index=0&id=df07c724&prod&lang=css&"
import style1 from "./Page6.vue?vue&type=style&index=1&id=df07c724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df07c724",
  null
  
)

export default component.exports